export const REQUEST_PENDING_CLAIMS: string = 'REQUEST_PENDING_CLAIMS';
export const SET_PENDING_CLAIMS: string = 'SET_PENDING_CLAIMS';
export const REQUEST_SEARCH_PENDING_CLAIMS: string =
  'REQUEST_SEARCH_PENDING_CLAIMS';
export const SET_SEARCH_PENDING_CLAIMS: string = 'SET_SEARCH_PENDING_CLAIMS';
